import { ReassignItemRequestForAdminState } from './reassignItemRequestForAdmin.types'

const reassignItemRequestForAdminInitialState: ReassignItemRequestForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default reassignItemRequestForAdminInitialState
